import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Welcome.css';

const Welcome: React.FC = () => {
  const { user } = useAuth();
  const [showBanner, setShowBanner] = React.useState(true);

  // Use proxprod for local testing, otherwise always use awsrealm for production
  const hostname = window.location.hostname;
  const gameHost = hostname.includes('proxprod') ? 'proxprod.majicrealm.com' : 'awsrealm.majicrealm.com';
  const gameUrl = `https://${gameHost}:8444`;

  const handlePlayNow = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch('/api/auth/game-ticket', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const { ticket } = await response.json();
        window.open(`${gameUrl}?ticket=${ticket}`, '_blank', 'noopener,noreferrer');
      } else {
        // Fallback: open game without ticket (manual login)
        window.open(gameUrl, '_blank', 'noopener,noreferrer');
      }
    } catch {
      // Fallback: open game without ticket
      window.open(gameUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="welcome-page">
      <div className="hero-section">
        <div
          className="hero-background-image"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/barbmagecastle.png)` }}
        />
        <div
          className="hero-background-image-right"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/barbarian2.png)` }}
        />
        <div className="hero-content hero-content-split">
          <div className="hero-left">
            <img src="/hugemajicrealmlogo.png" alt="The Majic Realm" className="hero-logo" />
            <p className="hero-subtitle">
              Established 1992 &mdash; No hand-holding. No quest markers. Just you, your friends, your wits, and a thriving world that's been growing since 1992. The Majic Realm is text-based MMO/MUD the way it was meant to be.
            </p>

            {user ? (
              <div className="welcome-back">
                <div className="action-buttons">
                  <Link to="/marketplace" className="cta-button secondary">
                    Visit Marketplace
                  </Link>
                  <a href="/help" className="cta-button secondary">
                    Realm Help
                  </a>
                  <button onClick={handlePlayNow} className="cta-button secondary">
                    Play Now!
                  </button>
                </div>
              </div>
            ) : (
              <div className="guest-actions">
                <Link to="/login" className="cta-button primary">
                  Enter the Realm
                </Link>
                <a href="/help" className="cta-button secondary">
                  Realm Help
                </a>
              </div>
            )}
            <div className="hero-gif-wrapper">
              <img src={`${process.env.PUBLIC_URL}/realmcap.gif`} alt="Gameplay preview" className="hero-gameplay-gif" />
            </div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          {showBanner && (
            <a href="/marketplace" className="promo-banner">
              <img
                src={`${process.env.PUBLIC_URL}/promo-banner.png`}
                alt="Promotion"
                className="promo-banner-img"
                onError={() => setShowBanner(false)}
              />
            </a>
          )}
          <h2 className="section-title">Explore the Realm</h2>
          <div className="features-grid">
            <a href="/help" className="feature-card feature-card-link">
              <div className="feature-icon">❓</div>
              <h3>Realm Help</h3>
              <p>What is the Majic Realm? How do I get there? How do I play? What are the terms of service?</p>
            </a>
            
            <Link to="/marketplace" className="feature-card feature-card-link">
              <div className="feature-icon">🏪</div>
              <h3>Magical Marketplace</h3>
              <p>Discover and acquire powerful items, spells, and enhancements for your journey.</p>
            </Link>
            
            <div className="feature-card">
              <div className="feature-icon">👑</div>
              <h3>Build Your Legacy</h3>
              <p>Create your character and shape your destiny in this ever-evolving world.</p>
            </div>
            
            <a href="/help/news" className="feature-card feature-card-link">
              <div className="feature-icon">📰</div>
              <h3>Realm News</h3>
              <p>Hear about the latest events and upcoming features!</p>
            </a>
          </div>
        </div>
      </div>

      <div className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">∞</div>
              <div className="stat-label">Adventures Await</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Always Online</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">🎮</div>
              <div className="stat-label">MUD Experience</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;